<a class="link" routerLink="/products/all" [queryParams]="routeParams" target="_blank">{{routeParams.productIdentifier}}<i class="pl-2 fas fa-external-link-alt"></i></a>
@if (!routeParams.productIdentifier) {
  -
}